import { BuildHTML } from "~/components/BuildHtml/BuildHtml";
import {
  FeatureHeader,
  FeatureHeaderProps,
} from "~/landing-pages/components/Feature/FeatureHeader/FeatureHeader";
import { LandingPageFeature } from "~/landing-pages/landing-page-types";
import {
  backgroundColorStyle,
  primaryTextColorStyle,
  secondaryTextColorStyle,
} from "~/landing-pages/shared-landing-page-styles";
import { tagToClassNameMap } from "~/landing-pages/utils/tagToClassNameMap";
import { Body, Headline } from "~/ui-library";

export type FeatureTwoByTwoGridProps = FeatureHeaderProps & {
  appearance: "dark" | "light";
  features: LandingPageFeature[];
};

const appearance = "light";

export const FeatureTwoByTwoGrid: React.FC<FeatureTwoByTwoGridProps> = ({
  features,
  ...headerProps
}) => (
  <div
    className={backgroundColorStyle({
      appearance,
    })}
  >
    <div>
      <FeatureHeader {...headerProps} appearance={appearance} />
      <div>
        <dl className="grid grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-2 lg:gap-12">
          {features.map((feature) => (
            <div key={feature.name} className="relative">
              <Headline
                as="dt"
                level={4}
                className={primaryTextColorStyle({ appearance })}
              >
                {feature.name}
              </Headline>
              <Body
                as="dd"
                className={secondaryTextColorStyle({
                  appearance,
                  className: "mt-xxs",
                })}
              >
                <BuildHTML
                  html={feature.description}
                  tagToClassNameMap={tagToClassNameMap}
                />
              </Body>
            </div>
          ))}
        </dl>
      </div>
    </div>
  </div>
);
